import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Cross from '../cross/Cross.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ClearButton',
  emits: ['click'],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "button button--clear button--link clear-button",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click'))),
    onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.$emit('click')), ["enter"]))
  }, [
    _cache[2] || (_cache[2] = _createElementVNode("span", { class: "clear-button__label" }, "Rensa filter", -1 /* HOISTED */)),
    _createVNode(Cross)
  ], 32 /* NEED_HYDRATION */))
}
}

})